import { render } from "./JiujitsuPage.vue?vue&type=template&id=664a3792"
import script from "./JiujitsuPage.vue?vue&type=script&lang=js"
export * from "./JiujitsuPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__